module.exports = __webpack_public_path__ + "static/media/mask_08.009ef86b.png";